import React, { useEffect } from "react";
import { DrawerActionTypes, Header } from "./header/index";
import { CartProvider } from "./hooks/contexts/cartContext";
import { useLocation } from "react-router-dom";
import { CookieConsentBanner } from "./shared/cookieConsent/cookieConsent";
import ScrollToTop from "./shared/scrollToTop";
import { disableGA, initGA } from "./services/functions/googleAnalytics";
import InstallDialog from "./shared/installPrompt/installAppDialog";
import { InstallPromptProvider } from "./contexts/useInstallContext";
import { ThemeProvider } from '@mui/material/styles';
import theme from "./theme";
import { TemporaryMenuCartProvider } from "./hooks/contexts/TemporaryMenuCartContext";


interface WithHeaderProps {
  children: React.ReactNode;
  showHeader?: boolean;
  enableHeaderHomeNavigation?: boolean;
  actionTypes?: DrawerActionTypes;
}

const GAListener: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // only log if user has already accepted cookies
    const hasConsent = document.cookie.includes("analytics_consent=true");
    const hasNoConsent = document.cookie.includes("analytics_consent_set=false")

    if (hasConsent) {
      initGA();
      console.log("We Have Cookie Consent")
    } else if (hasNoConsent) {
      disableGA();
      console.log("No Cookie Consent")
    } else {
      disableGA();
      console.log("No Cookie Consent Not Set")
    }

  }, [location]);

  return <>{children}</>;
};

const WithProviders: React.FC<WithHeaderProps> = ({ children, showHeader, enableHeaderHomeNavigation, actionTypes }) => {
  const _showHeader = showHeader != undefined ? showHeader : true
  const _enableHeaderHomeNavigation = enableHeaderHomeNavigation != undefined ? enableHeaderHomeNavigation : true
  const _actionTypes: DrawerActionTypes = actionTypes ? actionTypes : "side_drawer"

  return (
    <GAListener >
      <InstallPromptProvider>
        <ScrollToTop />
        <ThemeProvider theme={theme}>
          <CartProvider>
            <TemporaryMenuCartProvider>
              {
                _showHeader &&
                <Header actionTypes={_actionTypes} enableHeaderHomeNavigation={_enableHeaderHomeNavigation} />
              }
              {children}
            </TemporaryMenuCartProvider>
          </CartProvider>
        </ThemeProvider>
        <CookieConsentBanner />
        <InstallDialog />
      </InstallPromptProvider>
    </GAListener>
  );
};

export default WithProviders;